/*eslint-disable */
import React from 'react'
import SupersedeIcon from 'assets/icons/supersede-icon'
import {
  SITE_STATUS_CONFIRMED_ID,
  SITE_STATUS_DELISTED_ID,
  SITE_STATUS_DOES_NOT_QUALIFY,
  SITE_STATUS_DRAFT_ID,
  SITE_STATUS_NOMINATED_ID,
  SITE_STATUS_PROPOSED_ID,
  SITE_STATUS_REVIEWED_BY_RFP_ID,
  SITE_STATUS_SUPERSEDED_ID,
  SITE_STATUS_EDIT_ONLY_ID,
  SITE_STATUS_SUBMITTED_EDIT_ONLY_ID
} from './siteStatuses'
import BlockIcon from 'assets/icons/block-icon'
import DelistIcon from 'assets/icons/delist-icon'
import EditIcon from 'assets/icons/edit-icon'
import EyeIcon from 'assets/icons/eye-2-line-icon'
import NominateIcon from 'assets/icons/nominate-icon'
import CheckIcon from 'assets/icons/check-icon'
import ViewIcon from 'assets/icons/view-icon'
import ReassessIcon from 'assets/icons/reassess-icon'
import ConfirmIcon from 'assets/icons/confirm-icon'
import RemoveIcon from 'assets/icons/remove-icon16px'
import ReturnDraftIcon from 'assets/icons/return-draft-icon'
import { buildDetailsUrl, editOnly, buildMonitoringEvaluationUrl } from 'routing/constants'
import { requestReassesSite, requestEditSite } from 'api/site'
import { showErrorToast } from 'utils/toast'
import { RFP_ROLE_ID, BRC_ROLE_ID, NCG_ROLE_ID, SECRETARIAT_ROLE_ID, INDIVIDUAL_ROLE_ID, BIRDLIFE_SECRETARIAT_ROLE_ID } from './roles'
import { canBirdLifeSecretariatConfirmSite, canBirdLifeSecretariatDelistOrSupersede, canBirdLifeSecretariatSupersede } from 'utils/siteIbaAccess'
import AddMonitoringIcon from 'assets/icons/add-monitoring-icon'
import { requestSiteMonitoring } from 'api/monitoring'

// Shared function for RFP (role 3) and BRC (role 5) - they have identical logic
// approveEditOnlyCallBack is optional for contexts where edit-only functionality is not available (e.g., MapPage)
const getRfpAndBrcActionMenuItems = (site, history, approveCallBack, declineCallBack, toggleModal, setSite, approveEditOnlyCallBack, isMySite, setMonitoringForDeleting, setMonitoringForReverting, profile) => {
  const editOnlySite = site.SiteStatus.id === SITE_STATUS_EDIT_ONLY_ID || site.SiteStatus.id === SITE_STATUS_SUBMITTED_EDIT_ONLY_ID ? editOnly : null
  const editOnlySiteStatus = site.SiteStatus.id === SITE_STATUS_EDIT_ONLY_ID || site.SiteStatus.id === SITE_STATUS_SUBMITTED_EDIT_ONLY_ID
  const isRfp = profile?.RoleId === RFP_ROLE_ID
  if (site.SiteStatus.id === SITE_STATUS_PROPOSED_ID || site.SiteStatus.id === SITE_STATUS_SUBMITTED_EDIT_ONLY_ID) {
    return [
      {
        icon: <EyeIcon />,
        title: editOnlySiteStatus ? "reviewEditOnlySite" : 'review',
        onClick: () => {
          if (site.reassessmentFlag || editOnlySiteStatus) {
            return history(buildDetailsUrl(site.id, site.historyId || site.sitehistoryId, editOnlySite))
          }
          history(buildDetailsUrl(site.id))
          //TODO should find more elegant solution, maybe react-router-dom utils
        }
      },
      {
        icon: <CheckIcon />,
        title: editOnlySiteStatus ? "approveEditOnlySite" : 'approveSite',
        onClick: () => {
          if (editOnlySiteStatus && approveEditOnlyCallBack) {
            approveEditOnlyCallBack({ ...site, isApproved: true })
          } else {
            approveCallBack(site)
          }
        }
      },
      {
        icon: <ReturnDraftIcon />,
        title: editOnlySiteStatus ? "returnToEditOnly" : 'returnToDraft',
        onClick: () => {
          if (editOnlySiteStatus && approveEditOnlyCallBack) {
            approveEditOnlyCallBack({ ...site, isApproved: false })
          } else {
            declineCallBack(site)
          }
        }
      }
    ]
  }
  return [
    {
      icon: <EyeIcon />,
      title: 'viewSite',
      onClick: () => {
        if (site.reassessmentFlag || editOnlySiteStatus) {
          return history(buildDetailsUrl(site.id, site.historyId, editOnlySite))
        } else {
          if (site.SitesHistories && site.SitesHistories.length > 0) {
            const filteredSiteHistories = site.SitesHistories.filter(
              (item) =>
                item.SiteStatusId !== SITE_STATUS_EDIT_ONLY_ID &&
                item.SiteStatusId !== SITE_STATUS_SUBMITTED_EDIT_ONLY_ID
            )
            if (filteredSiteHistories.length === 0) {
              return history(buildDetailsUrl(site.id))
            }
            const sortedHistories = filteredSiteHistories.sort((a, b) => {
              // Sort by reassessmentFlag first (false first)
              if (a.reassessmentFlag === b.reassessmentFlag) {
                // If both flags are the same, sort by createdAt in descending order
                return new Date(b.createdAt) - new Date(a.createdAt)
              }
              return a.reassessmentFlag ? 1 : -1
            })
            return history(buildDetailsUrl(site.id, sortedHistories[0].historyId, editOnlySite))
          }
        }
        history(buildDetailsUrl(site.id))
        //TODO should find more elegant solution, maybe react-router-dom utils
      }
    },
    ...(() => {
      const siteEvaluations = Array.isArray(site?.monitoring)
        ? [...site.monitoring].sort((a, b) => Number(b.id) - Number(a.id))
        : []
      const confirmedMonitoring = siteEvaluations.find(
        (entry) => entry?.monitoring_status === SITE_STATUS_CONFIRMED_ID
      )
      return confirmedMonitoring
        ? [
            {
              icon: <EyeIcon />,
              title: 'viewMonitoringEvaluation',
              disabled: false,
              onClick: () => {
                handleGetMonitoring(site.id, confirmedMonitoring.id, history)
              }
            }
          ]
        : []
    })(),
    ...(() => {
      const siteEvaluations = site?.monitoring
      let targetEvaluation = null
      let lockedByOtherUser = false
      let alreadyEvaluated
      if (Array.isArray(siteEvaluations)) {
        targetEvaluation = siteEvaluations.find((entry) => {
          return entry && entry.monitor_users_id === profile.id && entry.monitoring_status === SITE_STATUS_DRAFT_ID
        })
        lockedByOtherUser = siteEvaluations.some((entry) => {
          const isDraft = entry && entry.monitoring_status === SITE_STATUS_DRAFT_ID
          const isOwnedByOther = entry && entry.monitor_users_id !== profile.id
          return isDraft && isOwnedByOther
        })
        alreadyEvaluated = siteEvaluations.some((entry) => entry?.monitoring_status === SITE_STATUS_CONFIRMED_ID)
      }
      const title =
        targetEvaluation && alreadyEvaluated
          ? 'editMonitoringRevaluation'
          : targetEvaluation
            ? 'editMonitoringEvaluation'
            : alreadyEvaluated && !lockedByOtherUser
              ? 'reEvaluateMonitoring'
              : 'addMonitoringEvaluation'
      const isDisabled = lockedByOtherUser
      const isRfpTargetEvaluation =
        Array.isArray(siteEvaluations) &&
        siteEvaluations.find((entry) => {
          return entry && entry.monitoring_status === SITE_STATUS_DRAFT_ID
        })
      if (isRfp) {
        if (!isRfpTargetEvaluation) return []
        return [
          {
            icon: <EditIcon />,
            title: 'editMonitoringEvaluation',
            disabled: false,
            onClick: () => {
              localStorage.setItem('isEdit', 'false')
              const monitoringId = isRfpTargetEvaluation.id || isRfpTargetEvaluation.monitoringId
              history(buildMonitoringEvaluationUrl(site.id, monitoringId))
            }
          }
        ]
      }
      return [
        {
          icon: targetEvaluation ? <EditIcon /> : <AddMonitoringIcon />,
          title,
          disabled: isDisabled,
          onClick: () => {
            if (isDisabled) return

            if (title === 'addMonitoringEvaluation' || title === 'reEvaluateMonitoring') {
              localStorage.setItem('isEdit', 'true')
            } else if (title === 'editMonitoringEvaluation' || title === 'editMonitoringRevaluation') {
              localStorage.setItem('isEdit', 'false')
            }

            const monitoringId = targetEvaluation?.id || targetEvaluation?.monitoringId
            if (monitoringId) {
              history(buildMonitoringEvaluationUrl(site.id, monitoringId))
              return
            }

            if (targetEvaluation) {
              return handleGetMonitoring(site.id, targetEvaluation.id, history)
            }

            return handleCreateMonitoring(site.id, profile.id, history)
          }
        }
      ]
    })(),
    ...(() => {
      const siteEvaluations = site?.monitoring
      let targetEvaluation = null
      if (Array.isArray(siteEvaluations)) {
        targetEvaluation = siteEvaluations.find((entry) => {
          return entry && entry.monitor_users_id === profile.id && entry.monitoring_status === SITE_STATUS_DRAFT_ID
        })
      }
      return isMySite && targetEvaluation
        ? [
            {
              icon: <RemoveIcon />,
              title: 'removeMonitoring',
              disabled: false,
              onClick: () => {
                setMonitoringForDeleting(targetEvaluation)
              }
            }
          ]
        : []
    })(),
    ...(() => {
      const siteEvaluations = Array.isArray(site?.monitoring)
        ? [...site.monitoring].sort((a, b) => Number(b.id) - Number(a.id))
        : []
      let targetEvaluation = null
      if (siteEvaluations.length > 0) {
        targetEvaluation = siteEvaluations.find((entry) => {
          return entry && entry.monitoring_status === SITE_STATUS_CONFIRMED_ID
        })
      }
      const isRfpTargetEvaluation =
        siteEvaluations.length > 0 &&
        siteEvaluations.find((entry) => {
          return entry && entry.monitoring_status === SITE_STATUS_DRAFT_ID
        })
      return isRfp && targetEvaluation && !isRfpTargetEvaluation
        ? [
            {
              icon: <RemoveIcon />,
              title: 'revertSubmission',
              disabled: false,
              onClick: () => {
                setMonitoringForReverting(targetEvaluation)
              }
            }
          ]
        : []
    })()
  ]
}

// Shared function for SECRETARIAT_ROLE_ID (role 4) and BIRDLIFE_SECRETARIAT_ROLE_ID (role 6)
// For BirdLife Secretariat, actions are conditional based on IBA status and criteria
const getBirdlifeSecretariatAndKbaSecretariatActionMenuItems = (
    site,
    history,
    changeStatusCallback,
    setSiteToPublish,
    setSiteToDelist,
    setIsSiteDoesNotQualified,
    setSiteForDeleting,
    toggleModal,
    setSite,
    approveEditOnlyCallBack,
    profile,
    isMySite,
    setMonitoringForDeleting,
    setMonitoringForReverting
  ) => {
    const editOnlySite = site.SiteStatus.id === SITE_STATUS_EDIT_ONLY_ID || site.SiteStatus.id === SITE_STATUS_SUBMITTED_EDIT_ONLY_ID ? editOnly : null
    const editOnlySiteStatus = site.SiteStatus.id === SITE_STATUS_EDIT_ONLY_ID || site.SiteStatus.id === SITE_STATUS_SUBMITTED_EDIT_ONLY_ID
    const isBirdLifeSecretariat = profile?.RoleId === BIRDLIFE_SECRETARIAT_ROLE_ID

    if (
      (site.SiteStatus && site.SiteStatus.id === SITE_STATUS_NOMINATED_ID) ||
      site.SiteStatus.id === SITE_STATUS_SUBMITTED_EDIT_ONLY_ID
    ) {
      const actionList = [
        {
          icon: <EyeIcon />,
          title: editOnlySiteStatus ? "reviewEditOnlySite" : 'review',
          onClick: () => {
            if (site.reassessmentFlag || editOnlySiteStatus) {
              return history(buildDetailsUrl(site.id, site.historyId || site.sitehistoryId, editOnlySite))
            }
            history(buildDetailsUrl(site.id))
            //TODO should find more elegant solution, maybe react-router-dom utils
          }
        }
      ]

      // For BirdLife Secretariat, only show confirm if site has IBA criteria and is from IBA country
      if (!isBirdLifeSecretariat || canBirdLifeSecretariatConfirmSite(site, profile)) {
        actionList.push({
          icon: <ConfirmIcon />,
          title: editOnlySiteStatus ? "approveEditOnlySite" : 'confirmAssessmentBtn',
          onClick: () => {
            if (editOnlySiteStatus) {
              approveEditOnlyCallBack({ ...site, isApproved: true })
            } else {
              setSiteToPublish({ ...site, isApproved: true })
            }
          }
        })
      }

      // Reject button - always show for both roles
      actionList.push({
        icon: <BlockIcon />,
        title: editOnlySiteStatus ? "returnToEditOnly" : 'rejectAssessmentBtn',
        onClick: () => {
          if (editOnlySiteStatus) {
            approveEditOnlyCallBack({ ...site, isApproved: false })
          } else {
            setSiteToPublish({ ...site, isApproved: false })
          }
        }
      })

      // Delist button - only show for BirdLife Secretariat if IBA status allows
      if (!isBirdLifeSecretariat || canBirdLifeSecretariatDelistOrSupersede(site, profile)) {
        actionList.push({
          icon: <DelistIcon />,
          title: 'delistAssessment',
          onClick: () => {
            setSiteToDelist(site)
          }
        })
      }

      if (site.historyId && !site.delist) {
        const delistIndex = actionList.findIndex(item => item.title === 'delistAssessment')
        if (delistIndex !== -1) {
          actionList.splice(delistIndex, 1)
        }
      }

      if (site.delist == undefined) {
        const delistIndex = actionList.findIndex(item => item.title === 'delistAssessment')
        if (delistIndex !== -1) {
          actionList.splice(delistIndex, 1)
        }
      }

      return actionList
    } else if (site.SiteStatus && site.SiteStatus.id === SITE_STATUS_DELISTED_ID) {
      const delistedActions = [
        {
          icon: <ViewIcon />,
          title: 'viewSite',
          onClick: () => {
            if (site.reassessmentFlag || editOnlySiteStatus) {
              return history(buildDetailsUrl(site.id, site.historyId, editOnlySite))
            } else {
              if (site.SitesHistories && site.SitesHistories.length > 0) {
                const sortedHistories = site.SitesHistories.sort((a, b) => {
                  // Sort by reassessmentFlag first (false first)
                  if (a.reassessmentFlag === b.reassessmentFlag) {
                    // If both flags are the same, sort by createdAt in descending order
                    return new Date(b.createdAt) - new Date(a.createdAt)
                  }
                  return a.reassessmentFlag ? 1 : -1
                })
                return history(buildDetailsUrl(site.id, sortedHistories[0].historyId, editOnlySite))
              }
            }
            history(buildDetailsUrl(site.id))
            //TODO should find more elegant solution, maybe react-router-dom utils
          }
        }
      ]

      // For BirdLife Secretariat, only show supersede if IBA status allows (5, 7, 8) and KBA status allows
      if (!isBirdLifeSecretariat || canBirdLifeSecretariatSupersede(site, profile)) {
        delistedActions.push({
          icon: <SupersedeIcon />,
          title:
            site.SiteStatus && site.SiteStatus.id && site.SiteStatus.id === SITE_STATUS_SUPERSEDED_ID
              ? 'revertToConfirmed'
              : 'supersede',
          onClick: () => {
            changeStatusCallback({ ...site, isApproved: true })
          }
        })
      }

      return delistedActions
    } else if (
      site.SiteStatus &&
      site.SiteStatus.id !== SITE_STATUS_CONFIRMED_ID &&
      site.SiteStatus.id !== SITE_STATUS_SUPERSEDED_ID &&
      site.SiteStatus.id !== SITE_STATUS_DRAFT_ID &&
      site.SiteStatus.id !== SITE_STATUS_EDIT_ONLY_ID
    ) {
      return [
        {
          icon: <ViewIcon />,
          title: 'viewSite',
          onClick: () => {
            if (site.reassessmentFlag || editOnlySiteStatus) {
              return history(buildDetailsUrl(site.id, site.historyId, editOnlySite))
            } else {
              if (site.SitesHistories && site.SitesHistories.length > 0) {
                const sortedHistories = site.SitesHistories.sort((a, b) => {
                  // Sort by reassessmentFlag first (false first)
                  if (a.reassessmentFlag === b.reassessmentFlag) {
                    // If both flags are the same, sort by createdAt in descending order
                    return new Date(b.createdAt) - new Date(a.createdAt)
                  }
                  return a.reassessmentFlag ? 1 : -1
                })
                return history(buildDetailsUrl(site.id, sortedHistories[0].historyId, editOnlySite))
              }
            }
            history(buildDetailsUrl(site.id))
          }
        }
      ]
    }
    const secretariatDropdownItems = [
      {
        icon: <ViewIcon />,
        title: 'viewSite',
        onClick: () => {
          if (site.reassessmentFlag || editOnlySiteStatus) {
            return history(buildDetailsUrl(site.id, site.historyId, editOnlySite))
          } else {
            if (site.SitesHistories && site.SitesHistories.length > 0) {
              const sortedHistories = site.SitesHistories.sort((a, b) => {
                // Sort by reassessmentFlag first (false first)
                if (a.reassessmentFlag === b.reassessmentFlag) {
                  // If both flags are the same, sort by createdAt in descending order
                  return new Date(b.createdAt) - new Date(a.createdAt)
                }
                return a.reassessmentFlag ? 1 : -1
              })
              return history(buildDetailsUrl(site.id, sortedHistories[0].historyId, editOnlySite))
            }
          }
          history(buildDetailsUrl(site.id))
          //TODO should find more elegant solution, maybe react-router-dom utils
        }
      },
      ...(() => {
        const siteEvaluations = Array.isArray(site?.monitoring)
          ? [...site.monitoring].sort((a, b) => Number(b.id) - Number(a.id))
          : []
        const confirmedMonitoring = siteEvaluations.find(
          (entry) => entry?.monitoring_status === SITE_STATUS_CONFIRMED_ID
        )
        return confirmedMonitoring
          ? [
              {
                icon: <EyeIcon />,
                title: 'viewMonitoringEvaluation',
                disabled: false,
                onClick: () => {
                  handleGetMonitoring(site.id, confirmedMonitoring.id, history)
                }
              }
            ]
          : []
      })(),
      ...(() => {
        const siteEvaluations = site?.monitoring
        let targetEvaluation = null
        let lockedByOtherUser = false
        let alreadyEvaluated
        if (Array.isArray(siteEvaluations)) {
          targetEvaluation = siteEvaluations.find((entry) => {
            return entry && entry.monitor_users_id === profile.id && entry.monitoring_status === SITE_STATUS_DRAFT_ID
          })
          lockedByOtherUser = siteEvaluations.some((entry) => {
            const isDraft = entry && entry.monitoring_status === SITE_STATUS_DRAFT_ID
            const isOwnedByOther = entry && entry.monitor_users_id !== profile.id
            return isDraft && isOwnedByOther
          })
          alreadyEvaluated = siteEvaluations.some((entry) => entry?.monitoring_status === SITE_STATUS_CONFIRMED_ID)
        }
        const title =
          targetEvaluation && alreadyEvaluated
            ? 'editMonitoringRevaluation'
            : targetEvaluation
              ? 'editMonitoringEvaluation'
              : alreadyEvaluated && !lockedByOtherUser
                ? 'reEvaluateMonitoring'
                : 'addMonitoringEvaluation'
        const isDisabled = lockedByOtherUser
        const isBirdLifeSecretariatTargetEvaluation =
          Array.isArray(siteEvaluations) &&
          siteEvaluations.find((entry) => {
            return entry && entry.monitoring_status === SITE_STATUS_DRAFT_ID
          })
       if (isBirdLifeSecretariat) {
          if (!isBirdLifeSecretariatTargetEvaluation) return []
          return [
            {
              icon: <EditIcon />,
              title: 'editMonitoringEvaluation',
              disabled: false,
              onClick: () => {
                localStorage.setItem('isEdit', 'false')
                const monitoringId = isBirdLifeSecretariatTargetEvaluation.id || isBirdLifeSecretariatTargetEvaluation.monitoringId
                history(buildMonitoringEvaluationUrl(site.id, monitoringId))
              }
            }
          ]
        }

        return [
          {
            icon: targetEvaluation ? <EditIcon /> : <AddMonitoringIcon />,
            title,
            disabled: isDisabled,
            onClick: () => {
              if (isDisabled) return

              if (title === 'addMonitoringEvaluation' || title === 'reEvaluateMonitoring') {
                localStorage.setItem('isEdit', 'true')
              } else if (title === 'editMonitoringEvaluation' || title === 'editMonitoringRevaluation') {
                localStorage.setItem('isEdit', 'false')
              }

              const monitoringId = targetEvaluation?.id || targetEvaluation?.monitoringId
              if (monitoringId) {
                history(buildMonitoringEvaluationUrl(site.id, monitoringId))
                return
              }

              if (targetEvaluation) {
                return handleGetMonitoring(site.id, targetEvaluation.id, history)
              }

              return handleCreateMonitoring(site.id, profile.id, history)
            }
          }
        ]
      })(),
      ...(() => {
        const siteEvaluations = site?.monitoring
        let targetEvaluation = null
        if (Array.isArray(siteEvaluations)) {
          targetEvaluation = siteEvaluations.find((entry) => {
            return entry && entry.monitor_users_id === profile.id && entry.monitoring_status === SITE_STATUS_DRAFT_ID
          })
        }
        return isMySite && targetEvaluation
          ? [
              {
                icon: <RemoveIcon />,
                title: 'removeMonitoring',
                disabled: false,
                onClick: () => {
                  setMonitoringForDeleting(targetEvaluation)
                }
              }
            ]
          : []
      })(),
      ...(() => {
        const siteEvaluations = Array.isArray(site?.monitoring)
          ? [...site.monitoring].sort((a, b) => Number(b.id) - Number(a.id))
          : []
        let targetEvaluation = null
        if (siteEvaluations.length > 0) {
          targetEvaluation = siteEvaluations.find((entry) => {
            return entry && entry.monitoring_status === SITE_STATUS_CONFIRMED_ID
          })
        }
        const isBirdLifeSecretariatTargetEvaluation =
        siteEvaluations.length > 0 &&
        siteEvaluations.find((entry) => {
          return entry && entry.monitoring_status === SITE_STATUS_DRAFT_ID
        })
        return isBirdLifeSecretariat && targetEvaluation && !isBirdLifeSecretariatTargetEvaluation
          ? [
              {
                icon: <RemoveIcon />,
                title: 'revertSubmission',
                disabled: false,
                onClick: () => {
                  setMonitoringForReverting(targetEvaluation)
                }
              }
            ]
          : []
      })()
    ]

    // For BirdLife Secretariat, only show supersede if IBA status allows (5, 7, 8) and KBA status allows
    if (!isBirdLifeSecretariat || canBirdLifeSecretariatSupersede(site, profile)) {
      secretariatDropdownItems.push({
        icon: <SupersedeIcon />,
        title:
          site.SiteStatus && site.SiteStatus.id && site.SiteStatus.id === SITE_STATUS_SUPERSEDED_ID
            ? 'revertToConfirmed'
            : 'supersede',
        onClick: () => {
          changeStatusCallback(site)
        }
      })
    }

    if (site.SiteStatus && site.SiteStatus.id && site.SiteStatus.id < SITE_STATUS_CONFIRMED_ID) {
      const supersedeIndex = secretariatDropdownItems.findIndex(item => item.title === 'supersede' || item.title === 'revertToConfirmed')
      if (supersedeIndex !== -1) {
        secretariatDropdownItems.splice(supersedeIndex, 1)
      }
    }

    if (site.SiteStatus && site.SiteStatus.id && site.SiteStatus.id == SITE_STATUS_EDIT_ONLY_ID) {
      const supersedeIndex = secretariatDropdownItems.findIndex(item => item.title === 'supersede' || item.title === 'revertToConfirmed')
      if (supersedeIndex !== -1) {
        secretariatDropdownItems.splice(supersedeIndex, 1)
      }
    }

    if (site.SiteStatus && site.SiteStatus.id && site.SiteStatus.id === SITE_STATUS_DRAFT_ID && site.historyId) {
      secretariatDropdownItems.push({
        icon: <RemoveIcon />,
        title: 'Remove',
        onClick: () => {
          setSiteForDeleting(site)
        }
      })
    }
    return secretariatDropdownItems
  }

  function handleCreateMonitoring(siteId, profileID, history) {
    requestSiteMonitoring(siteId, profileID).then((data) => {
      history(`/site/${siteId}/monitoring/${data.id}/about`)
      //TODO should find more elegant solution, maybe react-router-dom utils
    })
  }

  function handleGetMonitoring(siteId, monitoringId, history) {
    history(`/site/${siteId}/monitoring/${monitoringId}/about`)
  }

export const siteTableActionMenuItems = {
  [INDIVIDUAL_ROLE_ID]: (site, profile, history, setSiteToWorkWith, setSiteForDeleting, toggleModal, setSite, setSiteIsModalEditOpen, setEditOnlySiteToReject, isMySite, setMonitoringForDeleting) => {
    const editOnlySite = site.SiteStatus.id === SITE_STATUS_EDIT_ONLY_ID || site.SiteStatus.id === SITE_STATUS_SUBMITTED_EDIT_ONLY_ID ? editOnly : null
    const editOnlySiteStatus = site.SiteStatus.id === SITE_STATUS_EDIT_ONLY_ID || site.SiteStatus.id === SITE_STATUS_SUBMITTED_EDIT_ONLY_ID

    if ([SITE_STATUS_DRAFT_ID, SITE_STATUS_EDIT_ONLY_ID].includes(site.SiteStatus.id)) {
      return [
        {
          icon: <EditIcon />,
          title: 'edit',
          onClick: () => {
            if (site.reassessmentFlag || editOnlySiteStatus) {
              return history(buildDetailsUrl(site.id, site.historyId || site.sitehistoryId, editOnlySite))
            }
            history(buildDetailsUrl(site.id))
            //TODO should find more elegant solution, maybe react-router-dom utils
          }
        },
        {
          icon: <RemoveIcon />,
          title: 'Remove',
          onClick: () => {
            if (editOnlySiteStatus) {
              setEditOnlySiteToReject({ ...site, isApproved: false, delete: true })
            } else {
              setSiteForDeleting(site)
            }
          }
        }
      ]
    } else if (site && site.SiteStatus && site.SiteStatus.id === SITE_STATUS_REVIEWED_BY_RFP_ID) {
      return [
        {
          icon: <EyeIcon />,
          title: 'review',
          onClick: () => {
            if (site.reassessmentFlag || editOnlySiteStatus) {
              return history(buildDetailsUrl(site.id, site.historyId, editOnlySite))
            }
            history(buildDetailsUrl(site.id))
            //TODO should find more elegant solution, maybe react-router-dom utils
          }
        },
        {
          icon: <NominateIcon />,
          title: 'nominateSite',
          onClick: () => {
            setSiteToWorkWith(site)
          }
        }
      ]
    } else if (
      site &&
      site.SiteStatus &&
      (site.SiteStatus.id === SITE_STATUS_CONFIRMED_ID ||
        site.SiteStatus.id === SITE_STATUS_DELISTED_ID ||
        site.SiteStatus.id === SITE_STATUS_DOES_NOT_QUALIFY)
    ) {
      return [
        {
          icon: <ViewIcon />,
          title: 'viewSite',
          onClick: () => {
            if (site.SitesHistories && site.SitesHistories.length > 0) {
              const filteredSiteHistories = site.SitesHistories.filter(
                (item) =>
                  item.SiteStatusId !== SITE_STATUS_EDIT_ONLY_ID &&
                  item.SiteStatusId !== SITE_STATUS_SUBMITTED_EDIT_ONLY_ID
              )
              if (filteredSiteHistories.length === 0) {
                return history(buildDetailsUrl(site.id))
              }
              const sortedHistories = filteredSiteHistories.sort((a, b) => {
                // Sort by reassessmentFlag first (false first)
                if (a.reassessmentFlag === b.reassessmentFlag) {
                  // If both flags are the same, sort by createdAt in descending order
                  return new Date(b.createdAt) - new Date(a.createdAt)
                }
                return a.reassessmentFlag ? 1 : -1
              })
              return history(buildDetailsUrl(site.id, sortedHistories[0].historyId, editOnlySite))
            }
            history(buildDetailsUrl(site.id))
            //TODO should find more elegant solution, maybe react-router-dom utils
          }
        },
        {
          icon: <ReassessIcon />,
          title: 'reassessSite',
          disabled: false,
          onClick: () => {
            toggleModal()
            setSite({
              id: site.id
            })
            //TODO should find more elegant solution, maybe react-router-dom utils
          }
        },
        {
          icon: <EditIcon />,
          title: 'editNow',
          disabled: false,
          onClick: () => {
            setSiteIsModalEditOpen(site)
            //TODO should find more elegant solution, maybe react-router-dom utils
          }
        },
        ...(() => {
          const siteEvaluations = Array.isArray(site?.monitoring)
            ? [...site.monitoring].sort((a, b) => Number(b.id) - Number(a.id))
            : []
          const confirmedMonitoring = siteEvaluations.find(
            (entry) => entry?.monitoring_status === SITE_STATUS_CONFIRMED_ID
          )
          return confirmedMonitoring
            ? [
                {
                  icon: <EyeIcon />,
                  title: 'viewMonitoringEvaluation',
                  disabled: false,
                  onClick: () => {
                    handleGetMonitoring(site.id, confirmedMonitoring.id, history)
                  }
                }
              ]
            : []
        })(),
        (() => {
          const siteEvaluations = site?.monitoring
          let targetEvaluation = null
          let lockedByOtherUser = false
          let alreadyEvaluated
          if (Array.isArray(siteEvaluations)) {
            targetEvaluation = siteEvaluations.find((entry) => {
              return entry && entry.monitor_users_id === profile.id && entry.monitoring_status === SITE_STATUS_DRAFT_ID
            })
            lockedByOtherUser = siteEvaluations.some((entry) => {
              const isDraft = entry && entry.monitoring_status === SITE_STATUS_DRAFT_ID
              const isOwnedByOther = entry && entry.monitor_users_id !== profile.id
              return isDraft && isOwnedByOther
            })
            alreadyEvaluated = siteEvaluations.some((entry) => entry?.monitoring_status === SITE_STATUS_CONFIRMED_ID)
          }
          const title =
            targetEvaluation && alreadyEvaluated
              ? 'editMonitoringRevaluation'
              : targetEvaluation
                ? 'editMonitoringEvaluation'
                : alreadyEvaluated && !lockedByOtherUser
                  ? 'reEvaluateMonitoring'
                  : 'addMonitoringEvaluation'
          const isDisabled = lockedByOtherUser
          return {
            icon: targetEvaluation ? <EditIcon /> : <AddMonitoringIcon />,
            title,
            disabled: isDisabled,
            onClick: () => {
              if (isDisabled) return

              if (title === 'addMonitoringEvaluation' || title === 'reEvaluateMonitoring') {
                localStorage.setItem('isEdit', 'true')
              } else if (title === 'editMonitoringEvaluation' || title === 'editMonitoringRevaluation') {
                localStorage.setItem('isEdit', 'false')
              }

              if (targetEvaluation && (targetEvaluation.id || targetEvaluation.monitoringId)) {
                const monitoringId = targetEvaluation.id || targetEvaluation.monitoringId
                return history(buildMonitoringEvaluationUrl(site.id, monitoringId))
              }
              targetEvaluation
                ? handleGetMonitoring(site.id, targetEvaluation.id, history)
                : handleCreateMonitoring(site.id, profile.id, history)
            }
          }
        })(),
        ...(() => {
          const siteEvaluations = site?.monitoring
          let targetEvaluation = null
          if (Array.isArray(siteEvaluations)) {
            targetEvaluation = siteEvaluations.find((entry) => {
              return entry && entry.monitor_users_id === profile.id && entry.monitoring_status === SITE_STATUS_DRAFT_ID
            })
          }
          return isMySite && targetEvaluation
            ? [
                {
                  icon: <RemoveIcon />,
                  title: 'removeMonitoring',
                  disabled: false,
                  onClick: () => {
                    setMonitoringForDeleting(targetEvaluation)
                  }
                }
              ]
            : []
        })()
      ]
    }

    return [
      {
        icon: <ViewIcon />,
        title: 'viewSite',
        onClick: () => {
          if (site.reassessmentFlag || editOnlySiteStatus) {
            return history(buildDetailsUrl(site.id, site.historyId || site.sitehistoryId, editOnlySite))
          } else {
            if (site.SitesHistories && site.SitesHistories.length > 0) {
              const sortedHistories = site.SitesHistories.sort((a, b) => {
                // Sort by reassessmentFlag first (false first)
                if (a.reassessmentFlag === b.reassessmentFlag) {
                  // If both flags are the same, sort by createdAt in descending order
                  return new Date(b.createdAt) - new Date(a.createdAt)
                }
                return a.reassessmentFlag ? 1 : -1
              })
              return history(buildDetailsUrl(site.id, sortedHistories[0].historyId, editOnlySite))
            }
          }
          history(buildDetailsUrl(site.id))
          //TODO should find more elegant solution, maybe react-router-dom utils
        }
      }
    ]
  },
  [NCG_ROLE_ID]: (site, profile, history, setSiteToWorkWith, setSiteForDeleting, toggleModal, setSite, isMySite, setMonitoringForDeleting) => {
    const editOnlySite = site.SiteStatus.id === SITE_STATUS_EDIT_ONLY_ID || site.SiteStatus.id === SITE_STATUS_SUBMITTED_EDIT_ONLY_ID ? editOnly : null
    const editOnlySiteStatus = site.SiteStatus.id === SITE_STATUS_EDIT_ONLY_ID || site.SiteStatus.id === SITE_STATUS_SUBMITTED_EDIT_ONLY_ID

    if ([SITE_STATUS_DRAFT_ID, SITE_STATUS_EDIT_ONLY_ID].includes(site.SiteStatus.id)) {
      return [
        {
          icon: <EditIcon />,
          title: 'edit',
          onClick: () => {
            if (site.reassessmentFlag || editOnlySiteStatus) {
              return history(buildDetailsUrl(site.id, site.historyId, editOnlySite))
            }
            history(buildDetailsUrl(site.id))
            //TODO should find more elegant solution, maybe react-router-dom utils
          }
        },
        {
          icon: <RemoveIcon />,
          title: 'Remove',
          onClick: () => {
            setSiteForDeleting(site)
          }
        }
      ]
    } else if (site.SiteStatus.id === SITE_STATUS_REVIEWED_BY_RFP_ID) {
      return [
        {
          icon: <EyeIcon />,
          title: 'review',
          onClick: () => {
            if (site.reassessmentFlag || editOnlySiteStatus) {
              return history(buildDetailsUrl(site.id, site.historyId, editOnlySite))
            }
            history(buildDetailsUrl(site.id))
            //TODO should find more elegant solution, maybe react-router-dom utils
          }
        },
        {
          icon: <NominateIcon />,
          title: 'nominateSite',
          onClick: () => {
            setSiteToWorkWith(site)
          }
        }
      ]
    } else if (
      site.SiteStatus.id === SITE_STATUS_CONFIRMED_ID ||
      site.SiteStatus.id === SITE_STATUS_DELISTED_ID ||
      site.SiteStatus.id === SITE_STATUS_DOES_NOT_QUALIFY
    ) {
      return [
        {
          icon: <ViewIcon />,
          title: 'viewSite',
          onClick: () => {
            if (site.SitesHistories && site.SitesHistories.length > 0) {
              const sortedHistories = site.SitesHistories.sort((a, b) => {
                // Sort by reassessmentFlag first (false first)
                if (a.reassessmentFlag === b.reassessmentFlag) {
                  // If both flags are the same, sort by createdAt in descending order
                  return new Date(b.createdAt) - new Date(a.createdAt)
                }
                return a.reassessmentFlag ? 1 : -1
              })
              return history(buildDetailsUrl(site.id, sortedHistories[0].historyId, editOnlySite))
            }
            history(buildDetailsUrl(site.id))
            //TODO should find more elegant solution, maybe react-router-dom utils
          }
        },
        {
          icon: <ReassessIcon />,
          title: 'reassessSite',
          disabled: false,
          onClick: () => {
            requestReassesSite(site.id).then((data) => {
              if (data.error) {
                return showErrorToast(data.error, 'showBorder')
              }
              return history(buildDetailsUrl(site.id, data.historyId, editOnlySite))
            })
            //TODO should find more elegant solution, maybe react-router-dom utils
          }
        },
        {
          icon: <EditIcon />,
          title: 'editNow',
          disabled: false,
          onClick: () => {
            requestEditSite(site.id).then((data) => {
              if (data.error) {
                return showErrorToast(data.error, 'showBorder')
              }
              return history(buildDetailsUrl(site.id, data.historyId, editOnlySite))
            })
            //TODO should find more elegant solution, maybe react-router-dom utils
          }
        },
        ...(() => {
          const siteEvaluations = Array.isArray(site?.monitoring)
            ? [...site.monitoring].sort((a, b) => Number(b.id) - Number(a.id))
            : []
          const confirmedMonitoring = siteEvaluations.find(
            (entry) => entry?.monitoring_status === SITE_STATUS_CONFIRMED_ID
          )
          return confirmedMonitoring
            ? [
                {
                  icon: <EyeIcon />,
                  title: 'viewMonitoringEvaluation',
                  disabled: false,
                  onClick: () => {
                    handleGetMonitoring(site.id, confirmedMonitoring.id, history)
                  }
                }
              ]
            : []
        })(),
        (() => {
          const siteEvaluations = site?.monitoring
          let targetEvaluation = null
          let lockedByOtherUser = false
          let alreadyEvaluated
          if (Array.isArray(siteEvaluations)) {
            targetEvaluation = siteEvaluations.find((entry) => {
              return entry && entry.monitor_users_id === profile.id && entry.monitoring_status === SITE_STATUS_DRAFT_ID
            })
            lockedByOtherUser = siteEvaluations.some((entry) => {
              const isDraft = entry && entry.monitoring_status === SITE_STATUS_DRAFT_ID
              const isOwnedByOther = entry && entry.monitor_users_id !== profile.id
              return isDraft && isOwnedByOther
            })
            alreadyEvaluated = siteEvaluations.some((entry) => entry?.monitoring_status === SITE_STATUS_CONFIRMED_ID)
          }
          const title =
            targetEvaluation && alreadyEvaluated
              ? 'editMonitoringRevaluation'
              : targetEvaluation
                ? 'editMonitoringEvaluation'
                : alreadyEvaluated && !lockedByOtherUser
                  ? 'reEvaluateMonitoring'
                  : 'addMonitoringEvaluation'
          const isDisabled = lockedByOtherUser
          return {
            icon: targetEvaluation ? <EditIcon /> : <AddMonitoringIcon />,
            title,
            disabled: isDisabled,
            onClick: () => {
              if (isDisabled) return
              if (targetEvaluation && (targetEvaluation.id || targetEvaluation.monitoringId)) {
                const monitoringId = targetEvaluation.id || targetEvaluation.monitoringId
                return history(buildMonitoringEvaluationUrl(site.id, monitoringId))
              }
              targetEvaluation
                ? handleGetMonitoring(site.id, targetEvaluation.id, history)
                : handleCreateMonitoring(site.id, profile.id, history)
            }
          }
        })(),
        ...(() => {
          const siteEvaluations = site?.monitoring
          let targetEvaluation = null
          if (Array.isArray(siteEvaluations)) {
            targetEvaluation = siteEvaluations.find((entry) => {
              return entry && entry.monitor_users_id === profile.id && entry.monitoring_status === SITE_STATUS_DRAFT_ID
            })
          }
          return isMySite && targetEvaluation
            ? [
                {
                  icon: <RemoveIcon />,
                  title: 'removeMonitoring',
                  disabled: false,
                  onClick: () => {
                    setMonitoringForDeleting(targetEvaluation)
                  }
                }
              ]
            : []
        })()
      ]
    }

    return [
      {
        icon: <ViewIcon />,
        title: 'viewSite',
        onClick: () => {
          if (site.reassessmentFlag || editOnlySiteStatus) {
            return history(buildDetailsUrl(site.id, site.historyId, editOnlySite))
          } else {
            if (site.SitesHistories && site.SitesHistories.length > 0) {
              const sortedHistories = site.SitesHistories.sort((a, b) => {
                // Sort by reassessmentFlag first (false first)
                if (a.reassessmentFlag === b.reassessmentFlag) {
                  // If both flags are the same, sort by createdAt in descending order
                  return new Date(b.createdAt) - new Date(a.createdAt)
                }
                return a.reassessmentFlag ? 1 : -1
              })
              return history(buildDetailsUrl(site.id, sortedHistories[0].historyId, editOnlySite))
            }
          }
          history(buildDetailsUrl(site.id))
          //TODO should find more elegant solution, maybe react-router-dom utils
        }
      }
    ]
  },
  [RFP_ROLE_ID]: getRfpAndBrcActionMenuItems,
  [SECRETARIAT_ROLE_ID]: getBirdlifeSecretariatAndKbaSecretariatActionMenuItems,
  [BIRDLIFE_SECRETARIAT_ROLE_ID]: getBirdlifeSecretariatAndKbaSecretariatActionMenuItems,
  [BRC_ROLE_ID]: getRfpAndBrcActionMenuItems,
}
